// messages.js
export const ToastMessages = {
  USERNAME_REQUIRED: 'Username is required',
  INCORRECT_USERNAME_PASSWORD: 'Incorrect username or password',
  USER_NOT_FOUND: 'User not found',
  LOGIN_ERROR: 'An error occurred during login',
  EMAIL_REQUIRED: 'Email is required',
  USER_NOT_FOUND_OR_EMAIL_NOT_VERIFIED: 'User not found or email not verified',
  PASSWORD_RECOVERY_EMAIL_SENT: 'Password recovery email sent',
  PASSWORD_RECOVERY_ERROR: 'Error sending password recovery email',
};

export const DefaultTexts = {
  FORM_TITLE: 'Form Builder',
  LOGIN_BUTTON: 'Login',
  REGISTER_PROMPT: "Don't have an account? Register",
  FORGOT_PASSWORD_PROMPT: 'Forgot your password? Click here',
  PASSWORD_RECOVERY_TITLE: 'Password Recovery',
  PASSWORD_RECOVERY_BUTTON: 'Send Recovery Email',
};
